import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ROUTES } from "@/constants";
import { BackofficeLayout } from "@/layouts/backoffice";
import { PageLoading } from "@/components/atoms";
import { Login } from "@/pages/backoffice";
import {
  Castings,
  CastingPublicNew,
  Landing,
  Spaces,
} from "@/pages";
import { RequireAuth } from "../backoffice/guards/RequireAuth";
import { RequireManagerTenant } from "../backoffice/guards/RequireManagerTenant";
import { RequireRole } from "../backoffice/guards/RequireRole";

const LazyAdminRoutes = React.lazy(() => import("../backoffice/admin.routes"));
const LazyModeratorRoutes = React.lazy(() => import("../backoffice/moderator.routes"));
const LazyManagerRoutes = React.lazy(() => import("../backoffice/manager.routes"));

/**
 * Routes for the global public site (tercerespacio.com.ar)
 */
export const PublicRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path={ROUTES.public.home} element={<Landing />} />
      <Route path={ROUTES.public.spaces} element={<Spaces />} />
      <Route path={ROUTES.public.castings} element={<Castings />} />
      <Route path={ROUTES.public.castingsNew} element={<CastingPublicNew />} />
      <Route path={ROUTES.backoffice.login} element={<Login />} />
      <Route
        path={`${ROUTES.backoffice.admin}/*`}
        element={
          <RequireAuth>
            <RequireRole roles={["ADMIN"]}>
              <BackofficeLayout />
            </RequireRole>
          </RequireAuth>
        }
      >
        <Route
          path="*"
          element={
            <Suspense fallback={<PageLoading />}>
              <LazyAdminRoutes />
            </Suspense>
          }
        />
      </Route>
      <Route
        path={`${ROUTES.backoffice.moderar}/*`}
        element={
          <RequireAuth>
            <RequireRole roles={["ADMIN", "MODERATOR"]}>
              <BackofficeLayout />
            </RequireRole>
          </RequireAuth>
        }
      >
        <Route
          path="*"
          element={
            <Suspense fallback={<PageLoading />}>
              <LazyModeratorRoutes />
            </Suspense>
          }
        />
      </Route>
      <Route
        path={`${ROUTES.backoffice.manager}/*`}
        element={
          <RequireAuth>
            <RequireRole roles={["ADMIN", "MANAGER"]}>
              <RequireManagerTenant>
                <BackofficeLayout />
              </RequireManagerTenant>
            </RequireRole>
          </RequireAuth>
        }
      >
        <Route
          path="*"
          element={
            <Suspense fallback={<PageLoading />}>
              <LazyManagerRoutes />
            </Suspense>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to={ROUTES.public.home} replace />} />
    </Routes>
  );
};
